<app-header></app-header>
<div [@fadePage]="o.isActivated ? o.activatedRoute : ''">
   <router-outlet #o="outlet"></router-outlet> 
</div>

<app-footer></app-footer>
